import { createReducer } from '@reduxjs/toolkit';

import forgotPassword, { clearForgotPassword } from '../../thunks/auth/forgotPassword';

const initialState = {
  loading: false,
  error: null,
  data: null
};

const forgotPasswordReducer = createReducer(initialState, {
  [forgotPassword.pending]: (state) => ({
    ...state,
    loading: true,
    error: null,
  }),

  [forgotPassword.fulfilled]: (state, { payload: data }) => ({
    ...state,
    loading: false,
    data,
  }),

  [clearForgotPassword]: () => initialState,

  [forgotPassword.rejected]: (state, { payload: error }) => ({
    ...state,
    loading: false,
    error,
    data: null
  })
});

export default forgotPasswordReducer;
